import { defineMessages } from 'react-intl';

export default defineMessages({
    stepCoverables: {
        id: 'gateway.PremierPR.wizard.step.Coverables',
        defaultMessage: 'Coverables',
    },
    questions: {
        id: 'gateway.PremierPR.wizard.step.Questions',
        defaultMessage: 'Questions',
    },
    stepCoverages: {
        id: 'gateway.PremierPR.wizard.step.Coverages',
        defaultMessage: 'Coverages',
    },
    exposures: {
        id: 'gateway.PremierPR.wizard.step.Exposures',
        defaultMessage: 'Exposures',
    },
    anErrorOccurred: {
        id: 'quoteandbind.PremierPR.wizard.error',
        defaultMessage: 'Something went wrong during this process.',
    },
    anErrorOccurredTitle: {
        id: 'quoteandbind.PremierPR.wizard.error.title',
        defaultMessage: 'Error',
    },
    saveQuoteError: {
        id: 'quoteandbind.PremierPR.wizard.Unable to quote',
        defaultMessage: 'Unable to quote',
    },
    saveQuoteErrorMessage: {
        id: 'quoteandbind.PremierPR.wizard.An error occurred while attempting to quote.',
        defaultMessage: 'An error occurred while attempting to quote.',
    },
});
